export default __webpack_public_path__ + "static/media/projects.2db5ba17.svg";